<template>
  <div>
    <wc-data-box
      title='Timesheet Categories'
      :titleIcon='header.icon'
      :titleIconColor='header.color'
    >
      <v-card-text>
        Setup a way for the user to create categories. Each category can be linked to a division, and if its linked, then it shows
        the projects of that division.
      </v-card-text>
    </wc-data-box>
  </div>
</template>

<script>
export default {
  name: 'timesheet-categories',
  computed: {
    header () {
      return this.$store.state.icons.modules.timesheets
    }
  }
}
</script>
